import styled from 'styled-components';
import Alert from '@mui/material/Alert';
import getAlertStyle from './AlertBanner.style';

const StyledAlert = styled(Alert)`
  ${getAlertStyle}
`;

export default StyledAlert;
